import { Flex, Tag } from 'antd';
import { DotIcon } from '../Icons';

interface StatusTagProps {
  text: string;
  color?: string;
  iconColor?: string;
  className?: string;
  noDot?: boolean;
}

const StatusTag = ({ text, color, iconColor, className, noDot }: StatusTagProps) => {
  return (
    <Tag
      color={color}
      className={`flex w-fit gap-1 rounded-full text-sm ${className} mt-1`}
      icon={
        noDot ? undefined : (
          <Flex justify='center' align='center'>
            <DotIcon color={iconColor} className='mt-[2px]' />
          </Flex>
        )
      }
    >
      {text}
    </Tag>
  );
};

export default StatusTag;
